import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit,
} from '@angular/core';


import { CARD_PICTURE } from 'ib/internetbank-core/ib-constants/size';

import { PreloginProduct } from '../../biometrics-registration-wizard/models/models';

@Component({
	selector: 'app-registration-product-information',
	templateUrl: './registration-product-information.component.html',
	styleUrls: ['./registration-product-information.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class RegistrationProductInformationComponent implements OnInit {

	@Input()
	public preloginProduct: PreloginProduct;

	public CARD_PICTURE: typeof CARD_PICTURE = CARD_PICTURE;

	constructor() { }

	public ngOnInit(): void {
	}

}
